(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-product-bottom"]) return;
  try {
    
$(function(){
    $('a[href^="#"]').click(function(){
      let speed = 500;
      let href= $(this).attr("href");
      let target = $(href == "#" || href == "" ? 'html' : href);
      let position = target.offset().top;
      $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wish_insta"]) return;
  try {
    
    const HASHTAG_ID = '17842327183070202';
    const USER_ID = '17841448564853795';
    const ACCESS_TOKEN = 'EAACpnU1lIFcBAOO0htYE87aCQX4GA1iYFlX5gUEzZCmXEGp7KnsIGf0014BYiyGSbP9pxR1c0n56doqKYKoMqfF5oHvPFOZC3D5hloKSc1o9wTHSEtyZCyd1u0ZB8st1xPA3qlILPyhgxqQJlpaXzNVCIZCpp4qfAxoS9PpjImfNV3vrOiXoB ';
    const ACCESS_SCOPE = 'id,media_type,media_url,permalink,children{id,media_url}';
  
    const PAGINATE_BY = 12;
    
    const LIMIT = PAGINATE_BY * 2;
  
    function reqListener () {
      var response = JSON.parse(this.responseText);
      var wrapper = document.querySelector('.instagram_media__wrapper');
      while( wrapper.childElementCount < PAGINATE_BY && response.data ) {
        var d = response.data.shift();
        switch (d.media_type) {
          case "CAROUSEL_ALBUM":
            wrapper.innerHTML += `<div><a href='${d.permalink}' target='_brank'><img src='${d.children.data[0].media_url}'  /></a></div>`;
            break;
          case "IMAGE":
            wrapper.innerHTML += `<div><a href='${d.permalink}' target='_brank'><img src='${d.media_url}'  /></a></div>`;
            break;
          default:
            console.log(`media_type: ${d.media_type} has not been dispatched yet !!`);
            break;
        }
      }
    }
  
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("load", reqListener);
    xhr.open("GET", `https://graph.facebook.com/${HASHTAG_ID}/recent_media?user_id=${USER_ID}&access_token=${ACCESS_TOKEN}&fields=${ACCESS_SCOPE}&limit=${LIMIT}`);
    xhr.send();
  
  } catch(e) { console.error(e); }
})();
})();
